import { dealPipelines, type DealPipeline } from "../deals/pipelines";
import { toConfiguredValue, toText } from "./parseCell";
import type { ImportCell } from "./types";

/** Missing direction can be inferred from a unique ROVERO stage. Invalid values are rejected rather than creating invisible projects. */
export function resolveProjectImport(
  pipelineCell: ImportCell | undefined,
  stageCell: ImportCell | undefined,
  pipelines: DealPipeline[] = dealPipelines,
) {
  const direction = toText(pipelineCell ?? null);
  const stageText = toText(stageCell ?? null);
  const specified = toConfiguredValue(pipelineCell ?? null, pipelines);
  if (direction && !specified)
    throw new Error("Неизвестное направление проекта: " + direction);
  const inferred =
    stageText && !direction
      ? pipelines.find((item) =>
          toConfiguredValue(stageCell ?? null, item.stages),
        )
      : undefined;
  const pipeline =
    pipelines.find((item) => item.value === specified) ??
    inferred ??
    pipelines[0];
  const stage = toConfiguredValue(stageCell ?? null, pipeline.stages);
  if (stageText && !stage)
    throw new Error("Этап не относится к направлению проекта: " + stageText);
  return { pipeline: pipeline.value, stage: stage ?? pipeline.stages[0].value };
}
